module.exports = __webpack_public_path__ + "img/edge_activites_rando_sportive.5b384164.svg";